import axios from '@/libs/api.request.js';
import { WX_URL, IS_YW, IS_PRE } from '@/config';
import { cutHostName } from "@/libs/utils";
import { sort_ASCII } from "@/libs/utils";

export const getBaseUrl = () => {
  if (IS_YW) {
    if (IS_PRE) {
      return "//h5-pre.yuwanc.com";
    } else {
      return "//h5.yuwanc.com";
    }
  }
  const pathname = cutHostName(window.location.pathname);
  const name = window.location.hostname + pathname;
  switch (name) {
    case 'wxhdpre.hzwxbz999.cn/sdkhb':
      return '//h5.hzwxbz999.cn';
    case 'wxhdtest.hzwxbz999.cn/sdkhb':
      return '//h5test.hzwxbz999.cn';
    case 'wxhd.hzwxbz2.cn/sdkhb':
      return '//h5.hzwxbz3.cn';
  }
};

// 获取OPEN ID/用户接口
export const getUser = data => axios.request({ url: '/user', data });

// 绑定用户接口，微信公众号使用
export const bind = data => axios.request({ url: '/bind', data });

// 绑定手机号用户接口，微信公众号使用
export const cellBind = data => axios.request({ url: '/tel-bind', data });

// 绑定手机号用户验证码
export const cellBindVerify = data => axios.request({ 
  baseURL: getBaseUrl(), 
  url: '/user/sms/code/only-verification', 
  data
});

// 用户唯一ID绑定
export const tempIdBind = data => axios.request({ 
  baseURL: getBaseUrl(), 
  url: '/sdkPackets/temp-id-bind', 
  data
});

// 解绑用户接口
export const remove = data => axios.request({ url: '/remove', data });

// 获取微信签名接口
export const wechatSign = data => axios.request({ baseURL: WX_URL, url: '/api/get_wechat_sign', data });

// 获取研发红包微信用户信息接口
export const getRedPacketUserInfo = data => axios.request({ baseURL: getBaseUrl(), url: '/in-game-packet/wechat-user', data });
// 绑定研发红包微信用户信息接口
export const bindRedPacketUser = data => axios.request({ baseURL: getBaseUrl(), url: '/in-game-packet/wechat-bind', data });

// 获取绑定码
export const getBindCode = data => axios.request({ baseURL: getBaseUrl(),url: '/in-game-packet/check-user-bind', data });

// 清空绑定数据
export const clearBindData = data => axios.request({ baseURL: getBaseUrl(),url: '/in-game-packet/wechat-unbind', data });